export const namespace = 'locationGranularity';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
}

export const ActionType = {
  SET_LOCATION_GRANULARITY: `${namespace}/SET_LOCATION_GRANULARITY`,
}

export const setLocationGranularity = (locationGranularity = []) => ({
  type: ActionType.SET_LOCATION_GRANULARITY,
  payload: {
    locationGranularity
  }
})
